import request from "@/utils/request";
export function placeOrderDetailReport(data) {
  return request({
    url: "/whg-park/api/report/placeOrderDetailReport",
    method: "post",
    data: data
  });
}
export function placeOrderReport(data) {
  return request({
    url: "/whg-park/api/report/placeOrderReport",
    method: "post",
    data: data
  });
}